// Variante 2: Shader im ersten Bildschirm (nach 21st.dev „Animated Shader Hero“, Shader von Matthias Hurrle @atzedent),
// Farben auf das dunkle Rot der Seite gestellt. Läuft nur, solange der Bildschirm sichtbar ist; ohne Bewegung ein Standbild.
(() => {
  const vert = `#version 300 es
precision highp float;
in vec4 position;
void main(){gl_Position=position;}`;
  const frag = `#version 300 es
precision highp float;
out vec4 O;
uniform vec2 resolution;
uniform float time;
#define FC gl_FragCoord.xy
#define T time
#define R resolution
#define MN min(R.x,R.y)
float rnd(vec2 p){p=fract(p*vec2(12.9898,78.233));p+=dot(p,p+34.56);return fract(p.x*p.y);}
float noise(in vec2 p){vec2 i=floor(p),f=fract(p),u=f*f*(3.-2.*f);float a=rnd(i),b=rnd(i+vec2(1,0)),c=rnd(i+vec2(0,1)),d=rnd(i+1.);return mix(mix(a,b,u.x),mix(c,d,u.x),u.y);}
float fbm(vec2 p){float t=.0,a=1.;mat2 m=mat2(1.,-.5,.2,1.2);for(int i=0;i<5;i++){t+=a*noise(p);p*=2.*m;a*=.5;}return t;}
float clouds(vec2 p){float d=1.,t=.0;for(float i=.0;i<3.;i++){float a=d*fbm(i*10.+p.x*.2+.2*(1.+i)*p.y+d+i*i+p);t=mix(t,d,a);d=a;p*=2./(i+1.);}return t;}
void main(void){
  vec2 uv=(FC-.5*R)/MN,st=uv*vec2(2,1);
  vec3 col=vec3(0);
  float bg=clouds(vec2(st.x+T*.5,-st.y));
  uv*=1.-.3*(sin(T*.2)*.5+.5);
  for(float i=1.;i<12.;i++){
    uv+=.1*cos(i*vec2(.1+.01*i,.8)+i*i+T*.5+.1*uv.x);
    vec2 p=uv;
    float d=length(p);
    col+=.00125/d*(cos(sin(i)*vec3(1,2,3))+1.);
    float b=noise(i+p+bg*1.731);
    col+=.002*b/length(max(p,vec2(b*p.x*.02,p.y)));
    col=mix(col,vec3(bg*.25,bg*.06,bg*.045),d);
  }
  // auf die Farben der Seite: Helligkeit behalten, Ton Richtung Rot und Creme
  float l=dot(col,vec3(.299,.587,.114));
  col=mix(col,l*vec3(1.35,.42,.3),.8);
  O=vec4(col,1);
}`;

  const init = (root) => root.querySelectorAll('[data-shader]').forEach((canvas) => {
    if (canvas.__init) return;
    canvas.__init = true;
    const gl = canvas.getContext('webgl2', { alpha: false, antialias: false, depth: false, stencil: false, desynchronized: true, powerPreference: 'low-power' });
    if (!gl) return; // dann bleibt der Verlauf aus dem CSS
    const shader = (type, src) => {
      const s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s));
      return s;
    };
    const prog = gl.createProgram();
    gl.attachShader(prog, shader(gl.VERTEX_SHADER, vert));
    gl.attachShader(prog, shader(gl.FRAGMENT_SHADER, frag));
    gl.linkProgram(prog);
    gl.useProgram(prog);
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, 1, -1, -1, 1, 1, 1, -1]), gl.STATIC_DRAW);
    const pos = gl.getAttribLocation(prog, 'position');
    gl.enableVertexAttribArray(pos);
    gl.vertexAttribPointer(pos, 2, gl.FLOAT, false, 0, 0);
    const uRes = gl.getUniformLocation(prog, 'resolution');
    const uTime = gl.getUniformLocation(prog, 'time');

    let laeuft = false;
    let sichtbar = true;
    const zeichne = (t) => {
      gl.uniform2f(uRes, canvas.width, canvas.height);
      gl.uniform1f(uTime, t);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    };
    const groesse = () => {
      // Nebel braucht keine Schärfe: höchstens 320 Pixel breit rechnen, das Bild wird gestreckt (spart sehr viel Grafikleistung)
      const faktor = Math.min(0.5, 320 / Math.max(1, canvas.clientWidth));
      canvas.width = Math.round(canvas.clientWidth * faktor);
      canvas.height = Math.round(canvas.clientHeight * faktor);
      gl.viewport(0, 0, canvas.width, canvas.height);
      if (!laeuft) zeichne(8);
    };
    groesse();
    addEventListener('resize', groesse);
    if (!document.documentElement.classList.contains('motion')) return; // Standbild

    const start = performance.now();
    let letzte = 0;
    const schleife = (jetzt) => {
      if (!sichtbar) { laeuft = false; return; }
      if (jetzt - letzte > 32) { letzte = jetzt; zeichne(8 + (jetzt - start) / 1000); } // 30 Bilder pro Sekunde reichen
      requestAnimationFrame(schleife);
    };
    new IntersectionObserver(([e]) => {
      sichtbar = e.isIntersecting;
      if (sichtbar && !laeuft) { laeuft = true; requestAnimationFrame(schleife); }
    }).observe(canvas);
  });

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  init(document);
})();
